import { render, staticRenderFns } from "./ExtendOtherNutrientsPhosphorus.vue?vue&type=template&id=95083aba&scoped=true"
import script from "./ExtendOtherNutrientsPhosphorus.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsPhosphorus.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsPhosphorus.vue?vue&type=style&index=0&id=95083aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95083aba",
  null
  
)

export default component.exports